import { render, staticRenderFns } from "./registerTwo.vue?vue&type=template&id=68bbbe84&scoped=true&"
import script from "./registerTwo.vue?vue&type=script&lang=js&"
export * from "./registerTwo.vue?vue&type=script&lang=js&"
import style0 from "./registerTwo.vue?vue&type=style&index=0&id=68bbbe84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbbe84",
  null
  
)

export default component.exports